import React from 'react'
import Menus from './menu'

function Sider({location, sidebarCollapse, navOpenKeys, changeOpenKeys, user, currentHotel}) {

    const menusProps = {
        location,
        sidebarCollapse,
        navOpenKeys,
        changeOpenKeys
    }

    return (
        <aside className="main-sidebar" style={{paddingTop: '100px', backgroundColor: currentHotel.color ? currentHotel.color : '#265F84'}}>
            <section className="sidebar">
                <Menus {...menusProps} />
            </section>
        </aside>
    );
};

export default Sider



// WEBPACK FOOTER //
// ./src/components/layout/sider.js